<template>
  <v-container>
    <the-dialog-box
      ref="dialogBox"
      :submit="() => {}"
      :max-width="1500"
      :max-height="1000"
    >
      <template slot="header">
        <span class="headline">UPC Receiving</span>
      </template>
      <template slot="body">
        <v-container
          style="font-size: 1.3em !important;"
          fluid
          class="mt-3"
        >
          <v-row>
            <v-col class="pa-0" cols="1" md="3" sm="2" style="text-align:right">
              <v-row>
                <v-col class="text-center">
                  <h5 class="h5">
                    UPC Code
                  </h5> <span style="font-size: 1.5em;"> {{ qrCode }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <h6>
                    Inventory Class
                  </h6>
                  <v-chip
                    class="mt-1 mb-1"
                    text-color="white"
                    style="cursor: pointer;"
                    :color="inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.color : 'white'"
                  >
                    <span style="font-size: 20px; color: #fff !important;">{{ inventoryTag && inventoryTag.item && inventoryTag.item.classes ? inventoryTag.item.classes.name : '-' }}</span>
                  </v-chip>
                </v-col>
              </v-row>
              <v-row v-if="businessRulesGetBoolean('Inventory Sub Class') && inventoryTag && inventoryTag.item && inventoryTag.item.sub_classes && inventoryTag.item.sub_classes.length > 0">
                <v-col class="text-center">
                  <h6>Inventory Sub Classes</h6>
                  <v-chip 
                    v-for="subclass in inventoryTag.item.sub_classes" 
                    :key="`subclass-${subclass.id}`" 
                    class="my-1"
                    text-color="white"
                    style="display:block;margin-left:auto;margin-right:auto;min-width:7em;"
                    :style="{'width': `${subclass.name.length + 2}em`}"
                    :color="subclass.color || 'white'">
                    <span style="font-size: 20px; color: #fff !important;">{{ subclass.name }}</span>
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              class="pa-0"
              cols="1"
              md="1"
              sm="2"
              style="text-align:center"
            >
              <div
                style="border-left: 1px solid;
            height: 90%; margin-left:30px;"
              />
            </v-col>
            <v-col
              class="pa-0 pr-3"
              cols="3"
              md="2"
              sm="8"
            >
              <v-img
                :src="convertedPhoto(inventoryTag && inventoryTag.item ? inventoryTag.item.photo : '', inventoryTag && inventoryTag.item ? inventoryTag.item.mime_type : '')"
                contain
                height="100%"
                width="100%"
                class="profile-photo"
              />
            </v-col>
            <v-col
              class="pa-0 text-center"
              md="6"
              sm="12"
            >
              <v-row>
                <v-col lg="6" md="6" sm="8" class="text-center pt-0">
                  <h5 class="h5">Inventory Item</h5>
                  <span>{{ inventoryTag ? inventoryTag.item_full_name : '' }}</span>
                </v-col>
                <v-col lg="2" md="6" sm="4" class="text-center pt-0">
                  <h5 class="h5">Length</h5>
                  <span>{{ inventoryTag ? inventoryTag.length_name : '' }}</span>
                </v-col>
                <v-col lg="2" md="6" sm="4" class="text-center pt-0">
                  <h5 class="h5">Color</h5>
                  <span>{{ inventoryTag ? inventoryTag.color_name : '' }}</span>
                </v-col>
                <v-col lg="2" md="6" sm="4" class="text-center pt-0">
                  <h5 class="h5">UOM</h5>
                  <span>{{ inventoryTag ? inventoryTag.uom_name : '' }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col

                  class="text-center"
                >
                  <h5 class="h5">
                    Location
                  </h5>
                  <span>{{ inventoryTag ? inventoryTag.location_name : '' }}</span>
                </v-col>
                <v-col
                  class="text-center"
                >
                  <h5 class="h5">
                    Shelf
                  </h5>
                  <span>{{ inventoryTag ? inventoryTag.inventory_location_name : '' }}</span>
                </v-col>
                <v-col
                  class="text-center"
                >
                  <h5 class="h5">
                    Qty on Hand
                  </h5> <span> {{ inventoryTag ? inventoryTag.quantity_on_hand : '' }}</span>
                </v-col>
                <v-col
                  v-if="dangerLevel && dangerLevel.limit_level"
                  class="text-center"
                >
                  <h5 class="h5">
                    Limit Level
                  </h5> <span> {{ dangerLevel ? dangerLevel.limit_level : '' }}</span>
                </v-col>
                <v-col
                  v-if="dangerLevel && dangerLevel.danger_level"
                  class="text-center"
                >
                  <h5 class="h5">
                    Danger Level
                  </h5> <span> {{ dangerLevel ? dangerLevel.danger_level : '' }}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  md="3"
                  sm="6"
                  class="pt-12 text-center"
                >
                  <v-text-field
                    v-model="quantity"
                    :disabled="submittedSuccessfully"
                    :rules="[(v) => !!v || 'Quantity is required']"
                    type="number"
                  >
                    <template slot="label">
                      Quantity Received<RedAsterisk />
                    </template>
                  </v-text-field>
                </v-col>
                <v-col
                  md="4"
                  sm="6"
                  class="pt-12 text-center"
                >
                  <v-autocomplete
                    v-model="poNumber"
                    :items="inventoryPos"
                    :clearable="true"
                    label="PO#"
                    :rules="[(v) => !!v || 'PO# is required']"
                    :disabled="inventoryPoItemId != null"
                  >
                    <template slot="label">
                      PO#<RedAsterisk />
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  v-if="inventoryTag && inventoryTag.item && inventoryTag.item.classes && (inventoryTag.item.classes.id === inventoryClassIdGlass || inventoryTag.item.classes.id === inventoryClassIdVWDGlass)"
                  md="5"
                  sm="6"
                  class="pt-12 text-center"
                >
                  <v-file-input
                    v-model="supplierLabel"
                    accept="image/*"
                    capture="user"
                    label="Supplier Label"
                    item-text="name"
                    item-value="id"
                  >
                    <template slot="label">
                      Supplier Label<RedAsterisk />
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template #actions>
        <v-spacer />
        <v-btn :disabled="!submittedSuccessfully" @click="print" color="secondary">Print</v-btn>
        <v-btn @click="closeDialog">Close</v-btn>
        <v-btn @click="submit" :disabled="submittedSuccessfully" color="primary">Submit</v-btn>
      </template>
    </the-dialog-box>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  data: () => ({
    qrCode: '',
    inventoryTag: null,
    inventoryTagId: null,
    supplierLabel: null,
    dangerLevel: null,
    poNumber: '',
    quantity: 0,
    // maxInputQuantity: 0,

    inventoryPos: [],

    inventoryClassIdGlass: 5,
    inventoryClassIdVWDGlass: 7,
    inventoryClassIdParts: 11,

    inventoryPoItemId: null,

    data: null,
    submittedSuccessfully: false,
  }),
  computed: {
    ...mapGetters([
      'isPhysicalCountActivated',
      'currentPhysicalCount',
      'businessRulesGetBoolean',
    ]),
    ...mapState({
      userId: (state) => state.user.id,
    }),
  },
  created() {
  },
  mounted() {
  },
  methods: {
    async open(qrCode, data) {
      this.$refs.dialogBox.open();
      this.submittedSuccessfully = false;
      this.supplierLabel = null;
      this.dangerLevel = null;
      this.quantity = 0;
      this.qrCode = qrCode;

      if (data) {
        this.poNumber = data.po_number || '';
        this.inventoryPoItemId = data.inventory_po_item_id || null;
        this.data = data || null;
      }

      await this.getInventoryTag();
      await this.getDangerLevel();
      await this.getInventoryPos();
      await this.upsertInventoryBlob();
    },

    async upsertInventoryBlob() {
      try {
        const text = window.location.href;
        const name = this.inventoryTag.item?.name || `QR ${this.inventoryTag.inventory_tag}`;
        const res = await this.$api.inventoryBlob.store({ id: this.inventoryTag.inventory_tag, text, name });

        if (!res || res.err) {
          this.$bus?.$emit?.('showError', res?.errDesc || 'Failed to generate QR.');
        }
      } catch (e) {
        console.error('[inventory_blob/upsert] Error:', e);
        this.$bus?.$emit?.('showError', 'Unexpected error while generating QR.');
      }
    },

    async getInventoryTag() {
      if (!this.qrCode) return;

      const isQtyOnHandZero = 0;

      const submitModel = {
        filters: {
          inventory_tag: this.qrCode,
          is_qty_on_hand_o: isQtyOnHandZero,
        },
        includes: {
          is_include_item_image: true,
          is_include_supplier_label: true,
        },
      };

      const res = await this.$api.inventoryTag.read(submitModel);
      if (!res || !res.data || !res.data[0]) {
        this.$bus.$emit('showError', 'Inventory Tag not found');
        return;
      }
      const firstIndex = 0;
      let data = res.data[firstIndex];
      if (this.isPhysicalCountActivated && this.currentPhysicalCount && this.currentPhysicalCount.classes && this.currentPhysicalCount.classes.some((c) => c.id === data.item.inventory_class_id)) {
        // get the physical count record
        const submitModel2 = {
          filters: {
            inventory_tag: this.qrCode,
            physical_count_list_id: this.currentPhysicalCount.id,
          },
        };
        const res2 = await this.$api.physicalCount.read(submitModel2);
        if (res2 && res2.data && res2.data[0]) {
          const { item } = data;
          data = res2.data[0];
          data.quantity_on_hand = data.quantity;
          data.item = item;
        }
      }
      this.inventoryTagId = data.inventory_tag;
      this.inventoryTag = data;
    },

    async getDangerLevel() {
      if (this.inventoryTag && this.inventoryTag.item && this.inventoryTag.item.classes && this.inventoryTag.item.classes.id !== this.inventoryClassIdParts) return;
      if (!this.qrCode) return;

      const submitModel = {
        filters: {
          inventory_item_id: this.inventoryTag.inventory_item_id,
        },
      };

      const res = await this.$api.dangerLevel.read(submitModel);
      if (!res || res.length < 1) {
        this.dangerLevel = null;
        return;
      }

      const firstIndex = 0;
      this.dangerLevel = res[firstIndex];
    },

    async getInventoryPos() {
      const submitModel = {
        filters: {
          inventory_class_id: this.inventoryTag && this.inventoryTag.item && this.inventoryTag.item.classes && this.inventoryTag.item.classes.id,
        },
      };
      const res = await this.$api.inventoryPo.read(submitModel, null, 'read-simple');
      if (!res) {
        return;
      }
      this.inventoryPos = res;
    },

    convertedPhoto(photo, mimeType) {
      if (!photo) return '';
      return `data:${mimeType};base64, ${photo}`;
    },

    setMaxInputQuantity() {
      this.maxInputQuantity = this.dangerLevel && this.inventoryTag ? this.dangerLevel.limit_level - this.inventoryTag.quantity_on_hand : 0;
    },

    closeDialog() {
      if (this.submittedSuccessfully) this.$emit('success');
      this.$refs.dialogBox.close();
    },

    async submit() {
      if (this.submittedSuccessfully) return;
      if (this.isPhysicalCountActivated) {
        // if physical count is activated then if po_number is selected, then we need to query the inventory po and find the inventory po item associated with the currently selected parameters
        if (this.poNumber) {
          const submitData = {
            filters: {
              po_number: this.poNumber,
              inventory_item_id: this.inventoryTag.inventory_item_id,
              uom_id: this.inventoryTag.uom_id,
              length_id: this.inventoryTag.length_id,
              color_id: this.inventoryTag.color_id,
            },
          };

          const res = await this.$api.inventoryPoItem.read(submitData);
          if (!res || res.length === 0) {
            this.$bus.$emit('showError', 'No matching PO Item found for the selected parameters');
            return false;
          }

          // set inventory_po_item_id in data
          this.data = this.data || {};
          this.inventoryPoItemId = res[0].id;
          this.data.inventory_po_id = res[0].inventory_po_id;
        }
      }

      if (!this.inventoryTag) return false;

      this.$bus.$emit('loading');
      const data = new FormData();

      // Qr Code is treated as inv tag for now
      if (this.qrCode) {
        data.append('inventory_tag', this.qrCode);
      }

      if (this.quantity) {
        data.append('quantity', Math.floor(this.quantity));
      }

      if (this.userId) {
        data.append('created_by', this.userId);
      }

      if (this.poNumber) {
        data.append('po_number', this.poNumber);
      }

      if (this.supplierLabel) {
        data.append('supplier_label', this.supplierLabel);
      }

      if (this.inventoryPoItemId) {
        data.append('inventory_po_item_id', this.inventoryPoItemId);
      }

      const res = await this.$api.inventoryTag.upcReceiving(data);

      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading-stop');
        return false;
      }
      if (this.poNumber) {
        const submitData = new FormData();

        if (this.data.inventory_po_id) {
          submitData.append('inventory_po_id', this.data.inventory_po_id);
        }

        if (this.data.packaging_slip) {
          submitData.append('packaging_slip', this.data.packaging_slip);
        }

        if (this.data.packaging_slip_img) {
          submitData.append('packaging_slip_img', this.data.packaging_slip_img);
        }

        const resPo = await this.$api.inventoryPoItem.store(submitData, 'receiving');

        if (!resPo) {
          this.$bus.$emit('showError');
          this.$bus.$emit('loading-stop');
          return false;
        }
      }
      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');


      this.submittedSuccessfully = true;
      return true;
    },

    emitSuccess() {
      this.$emit('success');
    },
    async print() {
      //TODO review this function
      if (!this.submittedSuccessfully) return;
      try {
        this.$bus.$emit('loading');
        const WEBHOOK_MODULE_ID_CRYSTAL_INV_TAG = 11;
        const webhookData = {
          module_id: WEBHOOK_MODULE_ID_CRYSTAL_INV_TAG,
          inventory_tag_id: Number(this.inventoryTagId),
          quantity: this.quantity
        };
        const res = await this.$api.webhook.store( webhookData, 'run-download', { responseType: 'blob' });
        if (!res) return this.$bus.$emit('showError', 'Failed to generate PDF');

        const blob = res instanceof Blob ? res : (res.data instanceof Blob ? res.data : new Blob([res], { type: 'application/pdf' }));
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `inventory_tag_${this.inventoryTagId}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('[reprint] Error:', e);
        this.$bus.$emit('showError', 'Error generating PDF');
      } finally {
        this.$bus.$emit('loading-stop');
      }
    },
  },
};
</script>

<style scoped>
span{
  color: black !important;
}
</style>
